document.addEventListener("DOMContentLoaded", () => {
  const expertSections = document.querySelectorAll(".experts_media-content");

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const container = entry.target;
          const videoHTML = container.dataset.video;
          if (videoHTML) {
            container.innerHTML = videoHTML;
            container.removeAttribute("data-video");
            obs.unobserve(container);
          }
        }
      });
    },
    { threshold: 0.25 }
  );

  expertSections.forEach((section) => observer.observe(section));
});
